//custom event handler
//https://stackoverflow.com/questions/4386300/javascript-dom-how-to-remove-all-events-of-a-dom-object

let _eventHandlers = {}; // somewhere global
let CustomEventHandler = {};


CustomEventHandler.addHandler = (node, event, handler, capture = false) => {
    if (!(event in _eventHandlers)) {
        _eventHandlers[event] = []
    }
    // here we track the events and their nodes (note that we cannot
    // use node as Object keys, as they'd get coerced into a string
    _eventHandlers[event].push({ node: node, handler: handler, capture: capture })
    node.addEventListener(event, handler, capture)
}

CustomEventHandler.removeHandler = (targetNode, event) => {
    // remove listeners from the matching nodes
    _eventHandlers[event]
        .filter(({ node }) => node === targetNode)
        .forEach(({ node, handler, capture }) => node.removeEventListener(event, handler, capture))

    // update _eventHandlers global
    _eventHandlers[event] = _eventHandlers[event].filter(
        ({ node }) => node !== targetNode,
    )
}

CustomEventHandler.checkRemainHandler = function () {
    console.log(_eventHandlers);
    let key;
    for (key in _eventHandlers) {
        // console.log(_eventHandlers[key]);
        if (_eventHandlers[key].length > 0) {
            console.error('--> remain event!');
        }
    }
}

CustomEventHandler.removeAllHandler = () => {
    console.log('--> remove all handler');
    Object.entries(_eventHandlers).forEach(eventHandler => {
            let eventName = eventHandler[0];
            eventHandler[1].forEach(({ node, handler, capture }) => {
                // console.log('remove event : ' + eventName);
                // console.log(node);
                node.removeEventListener(eventName, handler, capture);
            });
        }
    )

    _eventHandlers = undefined;
    _eventHandlers = {};
}

CustomEventHandler.polyfillEvent = (evt) => {
    let event;
    if (typeof(Event) === 'function') {
        event = new Event(evt);
    }
    else {
        event = document.createEvent('Event');
        event.initEvent(evt, true, true);
    }
    return event;
}

export {CustomEventHandler};
